import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getFaqsListByFaqGroup } from "../api/getFaqsListByFaqGroup";
import { FaqData, FaqDataToUpdate } from "../types";

const getQueryKey = (faqGroupId: string): any => {
  return ["faqs", { faqGroupId }];
};

export const useFaqsListByFaqGroupQuery = (faqGroupId: string) => {
  return useQuery({
    queryKey: getQueryKey(faqGroupId),
    queryFn: () => getFaqsListByFaqGroup(faqGroupId),
  });
};

export const getFaqsListByFaqGroupQueryData = (faqGroupId: string) => {
  return queryClient.getQueryData<FaqData[]>(getQueryKey(faqGroupId));
};

export const setFaqsListByFaqGroupQueryData = (
  faqGroupId: string,
  data: FaqDataToUpdate[],
) => {
  queryClient.setQueryData(getQueryKey(faqGroupId), data);
};

export const invalidateFaqsListByFaqGroupQuery = async (faqGroupId: string) => {
  await queryClient.invalidateQueries({
    queryKey: getQueryKey(faqGroupId),
  });
};
